import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqSubmitOCRTasksMutation, type ResSubmitOCRTaskMutation } from './types'

export const submitOCRTasksMutation: MutationOptions<ResSubmitOCRTaskMutation, unknown, ReqSubmitOCRTasksMutation> = {
  mutationFn: (payload) => w.post(payload, API_ENDPOINTS.business.v1.ocr.submit.index).json(),
}
